import { cn } from '@/lib/cn';

interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner(props: SpinnerProps) {
  const { className, label } = props;
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8">
      <svg
        className={cn('h-6 w-6 animate-spin text-brand-400', className)}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden
      >
        <circle cx="12" cy="12" r="10" opacity="0.25" />
        <path d="M22 12a10 10 0 0 1-10 10" />
      </svg>
      {label && <p className="text-sm text-brand-500">{label}</p>}
    </div>
  );
}
